export const TitleWrapperStyles = {
  height: "100%",
  boxSizing: "border-box",

  px: { xs: 3, md: 4, lg: 7.5 },
  pt: { xs: 3, md: 6, lg: 14 },
  pb: { xs: 4, md: 6, lg: 14.5 },

  borderTopLeftRadius: "20px",
  borderTopRightRadius: { xs: "20px", md: 0 },
  borderBottomLeftRadius: { md: "20px" },
  borderLeft: "1px solid #E4E5E9",
  borderRight: { xs: "1px solid #E4E5E9", md: "none" },
  borderTop: "1px solid #E4E5E9",
  borderBottom: { md: "1px solid #E4E5E9" },
};

export const descriptionPartStyles = {
  height: "100%",
  boxSizing: "border-box",

  pl: { xs: 3, md: 5, lg: 8, xl: 16.25 },
  pr: { xs: 3, md: 5, lg: 8 },
  pt: { xs: 2, md: 6, lg: 14 },
  pb: { xs: 3, md: 6, lg: 14.5 },

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  borderBottomLeftRadius: { xs: "20px", md: 0 },
  borderBottomRightRadius: "20px",
  borderTopRightRadius: { md: "20px" },
  borderLeft: { xs: "1px solid #E4E5E9", md: "none" },
  borderTop: { md: "1px solid #E4E5E9" },
  borderRight: "1px solid #E4E5E9",
  borderBottom: "1px solid #E4E5E9",
  bgcolor: "background.default",
};

export const iconStyles = {
  width: 28,
  height: 28,
  "& img": {
    width: 21,
    height: 21,
  },
};
